module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_AF.b336857f.txt";